// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__rCE12","content":"Consent_content__STQxy","footer":"Consent_footer__1NAUO"};